export const SET_USERCONTEXT = 'SET_USERCONTEXT'
